export { default } from './NumbersEdit.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersEdit/index.js